import React from 'react'
import baseLoadable from '@loadable/component'
import type {
  DefaultComponent,
  LoadableClassComponent,
  LoadableComponent,
  Options,
  OptionsWithoutResolver,
  OptionsWithResolver,
} from '@loadable/component'

import PageSkeleton from 'compositions/PageSkeleton/PageSkeleton'


declare function loadableFunc<Props, Module = DefaultComponent<Props>>(
  loadFn: (props: Props) => Promise<Module>,
  options: OptionsWithResolver<Props, Module>,
): LoadableComponent<Props>;

declare function loadableFunc<Props>(
  loadFn: (props: Props) => Promise<DefaultComponent<Props>>,
  options?: OptionsWithoutResolver<Props>,
): LoadableComponent<Props>;

declare function loadableFunc<Component extends React.ComponentClass<any>>(
  loadFn: (props: React.ComponentProps<Component>) => Promise<Component | { default: Component }>,
  options?: Options<React.ComponentProps<Component>, Component>,
): LoadableClassComponent<Component>;

type LoadableFunc = typeof loadableFunc

export const loadable: LoadableFunc = (loadFn, options) => baseLoadable(loadFn, { fallback: <PageSkeleton />, ...options })
